let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fgTaG")).then(() => parcelRequire('7y2Wl'));